import { Outlet } from 'react-router-dom'

export const ManagementPages = () => {
    return <Outlet />
}
